import React, { FC, useState } from 'react';
import { Link } from 'gatsby';

import Image from '../image';

interface Props {
  to: string;
  src: string;
  alt: string;
  hoverImage: string;
}

const LinkedImage: FC<Props> = ({ to, src, alt, hoverImage }) => {

  const [image, setImage] = useState(src);

  function watchMouseOver() {
    setImage(hoverImage);
  }

  function watchMouseOut() {
    setImage(src);
  }

  return (
    <Link to={to}>
      <Image src={image} alt={alt} onMouseOver={watchMouseOver} onMouseOut={watchMouseOut} />
    </Link>
  );
};

export default LinkedImage;
